module.exports = __webpack_public_path__ + "static/media/logo.c3dbb1d1.ico";